export default __webpack_public_path__ + "static/media/js.b923402a.PNG";